import { render, staticRenderFns } from "./ModalPowerInfo.vue?vue&type=template&id=38f15709&scoped=true"
import script from "./ModalPowerInfo.vue?vue&type=script&lang=js"
export * from "./ModalPowerInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalPowerInfo.vue?vue&type=style&index=0&id=38f15709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f15709",
  null
  
)

export default component.exports